import React from 'react';
import propTypes from './propTypes';

const AboutFuelDelivery = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M14.75 16.4087C14.2334 16.3326 13.732 16.21 13.25 16.0453V19.5C13.25 20.88 14.37 22 15.75 22C17.13 22 18.25 20.88 18.25 19.5V16.199C17.7659 16.3316 17.2645 16.4224 16.75 16.4674V19.5C16.75 20.05 16.3 20.5 15.75 20.5C15.2 20.5 14.75 20.05 14.75 19.5V16.4087Z" fill="currentColor" />
    <path d="M11.75 15.3629V22H1.75V6C1.75 4.9 2.65 4 3.75 4H8.4981C8.16456 4.62424 7.90666 5.29499 7.73663 6H3.75V11H8.04455C8.31546 11.718 8.68079 12.3897 9.1254 13H3.75V20H9.75V13.7609C10.3303 14.3901 11.0043 14.9315 11.75 15.3629Z" fill="currentColor" />
    <path d="M13.41 9.41L12 8L16 4L20 8L18.59 9.42L17 7.83V12H15V7.83L13.41 9.41Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M23 8C23 11.866 19.866 15 16 15C12.134 15 9 11.866 9 8C9 4.13401 12.134 1 16 1C19.866 1 23 4.13401 23 8ZM21 8C21 10.7614 18.7614 13 16 13C13.2386 13 11 10.7614 11 8C11 5.23858 13.2386 3 16 3C18.7614 3 21 5.23858 21 8Z" fill="currentColor" />
  </svg>
);

AboutFuelDelivery.propTypes = propTypes;

export default AboutFuelDelivery;
